import React from "react";
function TabSelector({ tabIndex, components }) {
  return <div className="current-tab-div">{components[tabIndex]}</div>;
}
export default TabSelector;
